import { InjuriesFormValues } from "Components/Features/CheckPrice/Products/RiskProducts/riskProductsInterfaces";
import { DamageRecentYears } from "Components/Form/RecentDamages/recentDamagesInterfaces";
import { isDefined } from "Utils/functions";

export const mapInjuriesToForm = (
  damageCountRecentYears: number | undefined,
  yearOfLastDamage: number | undefined,
): InjuriesFormValues => {
  const injuries =
    isDefined(damageCountRecentYears) && damageCountRecentYears === 1
      ? DamageRecentYears.ONE
      : DamageRecentYears.NONE;
  const injuryYear =
    isDefined(yearOfLastDamage) && injuries === DamageRecentYears.ONE
      ? String(yearOfLastDamage)
      : undefined;
  return { injuries, injuryYear };
};

export const mapInjuriesToAnimalForm = (
  damageCountRecentYears: number | undefined,
  yearOfLastDamage: number | undefined,
): InjuriesFormValues => {
  let injuries;

  if (damageCountRecentYears === 2) {
    injuries = DamageRecentYears.TWO_OR_MORE;
  } else if (damageCountRecentYears === 1) {
    injuries = DamageRecentYears.ONE;
  } else {
    injuries = DamageRecentYears.NONE;
  }

  const injuryYear =
    isDefined(yearOfLastDamage) && injuries === DamageRecentYears.ONE
      ? String(yearOfLastDamage)
      : undefined;

  return { injuries, injuryYear };
};

export const mapFormToInjuries = (
  injuries: DamageRecentYears,
  injuryYear: string | undefined,
): {
  damageCountRecentYears: number;
  yearOfLastDamage?: number;
} => ({
  damageCountRecentYears: Number(injuries),
  yearOfLastDamage:
    isDefined(injuryYear) && injuries === DamageRecentYears.ONE
      ? Number(injuryYear)
      : undefined,
});
